module.exports = __webpack_public_path__ + "img/icon_form_select2.3a343e36.svg";